/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetKernelImagesForPickerQueryVariables = Types.Exact<{
  projectLanguage: Types.ProjectLanguage;
}>;

export type GetKernelImagesForPickerQuery = {
  readonly __typename: "Query";
  readonly getDefaultKernelImage: c.KernelImage;
  readonly getKernelImages: ReadonlyArray<{
    readonly __typename: "KernelImageConfig";
    readonly id: c.KernelImage;
    readonly priority: number;
    readonly humanName: string;
  }>;
};

export const GetKernelImagesForPickerDocument = /*#__PURE__*/ gql`
  query GetKernelImagesForPicker($projectLanguage: ProjectLanguage!) {
    getDefaultKernelImage(projectLanguage: $projectLanguage)
    getKernelImages(projectLanguage: $projectLanguage) {
      id
      priority
      humanName
    }
  }
`;

/**
 * __useGetKernelImagesForPickerQuery__
 *
 * To run a query within a React component, call `useGetKernelImagesForPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKernelImagesForPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKernelImagesForPickerQuery({
 *   variables: {
 *      projectLanguage: // value for 'projectLanguage'
 *   },
 * });
 */
export function useGetKernelImagesForPickerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetKernelImagesForPickerQuery,
    GetKernelImagesForPickerQueryVariables
  > &
    (
      | { variables: GetKernelImagesForPickerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetKernelImagesForPickerQuery,
    GetKernelImagesForPickerQueryVariables
  >(GetKernelImagesForPickerDocument, options);
}
export function useGetKernelImagesForPickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetKernelImagesForPickerQuery,
    GetKernelImagesForPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetKernelImagesForPickerQuery,
    GetKernelImagesForPickerQueryVariables
  >(GetKernelImagesForPickerDocument, options);
}
export function useGetKernelImagesForPickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetKernelImagesForPickerQuery,
    GetKernelImagesForPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetKernelImagesForPickerQuery,
    GetKernelImagesForPickerQueryVariables
  >(GetKernelImagesForPickerDocument, options);
}
export type GetKernelImagesForPickerQueryHookResult = ReturnType<
  typeof useGetKernelImagesForPickerQuery
>;
export type GetKernelImagesForPickerLazyQueryHookResult = ReturnType<
  typeof useGetKernelImagesForPickerLazyQuery
>;
export type GetKernelImagesForPickerSuspenseQueryHookResult = ReturnType<
  typeof useGetKernelImagesForPickerSuspenseQuery
>;
export type GetKernelImagesForPickerQueryResult = Apollo.QueryResult<
  GetKernelImagesForPickerQuery,
  GetKernelImagesForPickerQueryVariables
>;
